import React, { useState, useEffect } from "react";
import { Container, Button } from "react-floating-action-button";
import Chatbot from "./ChatbotWidget";
import axios from "axios";
import { DirectLine } from "botframework-directlinejs";
import { LP_CHATBOT_TOKEN } from "../../App/serverConfig";
import { adalApiFetch } from "../../adalConfig";
import AADService from "../../AADService";
import chatIcon from "./assets/images/chatIcon.png";
import chevronDown from "./assets/images/chevron-down.png";

const FloatingButton = () => {
  const [toggle, setToggle] = useState(false);
  const [dlToken, setDlToken] = useState();
  const [userId, setUserId] = useState();

  const AzureADService = new AADService();
  const user = AzureADService.getUser().userName;

  const userDlId = "dl_" + user;

  const fetchData = async () => {
    await adalApiFetch(axios, LP_CHATBOT_TOKEN, {
      method: "post",
      data: { User: { Id: userDlId } },
    })
      .then(function(response) {
        setDlToken(new DirectLine({ token: response.data }));
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  useEffect(() => {
    setUserId(userDlId);
    fetchData();
  }, []);

  const handleClose = (toggleState) => {
    setToggle(toggleState);
  };

  const handleOpen = async (open) => {
    setToggle(open);
    fetchData();
  };

  return (
    <Container className="float-btn-container">
      {!toggle && (
        <Button onClick={() => handleOpen(true)}>
          <img className="chatbot-icon" src={chatIcon} alt="chatIcon" />
        </Button>
      )}
      {toggle && (
        <>
          <img
            className="chatbot-down"
            src={chevronDown}
            alt="chevronDown"
            onClick={() => handleClose(false)}
          />
          <Chatbot
            handleClose={handleClose}
            directLine={dlToken}
            user={userId}
          />
        </>
      )}
    </Container>
  );
};

export default FloatingButton;
